export default "<div class=\"login-page\">\r\n    <login-form></login-form>\r\n</div>\r\n\r\n";